import React, { Component } from "react";
import Modal from "react-responsive-modal";
import "./ManualEntry.css";
import { Row, Col } from "react-bootstrap";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { translations } from "../containers/assets/translations";
import { B2B_PROXY } from "../containers/assets/config";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import { ToastContainer, ToastStore } from "react-toasts";
import { FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import axios from "axios";

export default class EditTicket extends Component {
  constructor(props) {
    super(props);
    this.saveManualEntry = this.saveManualEntry.bind(this);
    this.handleChangeOfInputSearchFields =
      this.handleChangeOfInputSearchFields.bind(this);
    this.handleChangeOfCombo = this.handleChangeOfCombo.bind(this);
    this.connectSerialDevice = this.connectSerialDevice.bind(this);
    this.getTicket = this.getTicket.bind(this);
    this.deleteManualEntry = this.deleteManualEntry.bind(this);
    let birthDate = "";
    let travelDocumentDeletionDate = "";
    let editDocType = "";
    if (this.props.editPerson) {
      birthDate =
        this.props.editData.BirthDate.substr(0, 4) +
        "-" +
        this.props.editData.BirthDate.substr(-4, 2) +
        "-" +
        this.props.editData.BirthDate.substr(-2);

      travelDocumentDeletionDate =
        this.props.editData.PassportDelDate.substr(0, 4) +
        "-" +
        this.props.editData.PassportDelDate.substr(-4, 2) +
        "-" +
        this.props.editData.PassportDelDate.substr(-2);

      editDocType = this.props.editData.DocType.trim();
    }

    this.state = {
      ChangedData: false,
      port: null,
      baudRate: 9600,
      dataBits: 8,
      stopBits: 1,
      parity: 'none',
      bufferSize: 255,
      companyAbbreviation: this.props.companyAbbreviation,
      TicketNumberME: this.props.editData.TicketNumber,
      PNRME: this.props.reservationNumber,
      SurnameME: this.props.editData.Surname,
      NameME: this.props.editData.Name,
      MaidenME: this.props.editData.MaidenName,
      BirthDateME: birthDate,
      BirthPlaceME: this.props.editData.BirthPlace,
      TravelDocNumberME: this.props.editData.PassportNumber,
      TravelDocIssueDateME: travelDocumentDeletionDate,
      OccupationME: this.props.editData.Occupation,
      ComingFromME: this.props.editData.CommingFrom,
      GoingToME: this.props.editData.GoingTo,
      AddressMoroccoME: this.props.editData.AddressInMorocco,
      PhoneDuringStayME: this.props.editData.PhoneDuringStay,
      VisitReasonME: this.props.editData.MainReasonForVisit,
      CabinSeatNumberME: this.props.editData.CabinSeatNumber,
      BerthME: this.props.editData.Berth,
      VisaNumberME: this.props.editData.VisaNumber,
      RegistrationPlatesME: this.props.editData.RegistrationNumber,
      DriverNameME: this.props.editData.DriverName,
      LengthME: this.props.editData.Length,
      HeightME: this.props.editData.Height,
      ModelME: this.props.editData.Model,
      BrandME: this.props.editData.Brand,
      AgeCateg: this.props.editData.AgeCategory,
      Gender: this.props.editData.Gender,
      Nation: this.props.editData.Nationality,
      SpecialServ: this.props.editData.SpecialServicesReq,
      DocType: editDocType,
      ResidCountry: this.props.editData.CountryOfUsualResidence,
      AccomTypePass: this.props.editData.AccommodationType,
      AccomTypeVeh: this.props.editData.AccommodationType,
      username: this.props.username,
      userGroup: this.props.userGroup,
      password: this.props.password,
      loadingSpinner: false,
      AccomPass: [],
      AccomVeh: [],
      AgeType: [],
      Countries: [],
      Docs: [],
    };
    this.isUnmounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.lastScannedMRZ &&
      (!prevProps.lastScannedMRZ || this.props.lastScannedMRZ.timestamp !== prevProps.lastScannedMRZ.timestamp)) {
      this.processCleanData(this.props.lastScannedMRZ.data);
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  connectSerialDevice = async () => {
    this.props.onRequestPort();
  };

  processCleanData = (data) => {
    // Remove non-printable characters and whitespace from ends
    const cleanedData = data.replace(/[\x00-\x1F\x7F-\x9F]/g, '').trim();
    if (cleanedData.length >= 88 || cleanedData.includes('<<')) {
      this.parseData(cleanedData);
    }
  }

  parseData = (rawData) => {
    // MRZ can come as one 88-char string or two 44-char lines
    // We normalize it to a single string first
    let normalized = rawData.replace(/\s/g, '');

    // Find the start of the MRZ (usually starts with 'P<')
    const startIndex = normalized.indexOf('P<');
    if (startIndex === -1) return;

    const mrz = normalized.substring(startIndex);
    const firstLine = mrz.substring(0, 44);
    const secondLine = mrz.substring(44, 88);

    if (firstLine.length < 44 || secondLine.length < 44) return;

    // 1. Parse Nationality (3-letter ISO code)
    // Format: P<CAN (Canada), P<GRC (Greece), etc.
    const nationalityCode = firstLine.substring(2, 5);

    // 2. Parse Names: Strip 'P<XXX'
    const namePart = firstLine.substring(5);
    const namesParts = namePart.split('<<');
    const rawSurname = namesParts[0] ? namesParts[0].replace(/</g, " ").trim() : "";
    const rawFirstName = namesParts.length > 1 ? namesParts[1].replace(/</g, " ").trim() : "";

    // 3. Parse Passport Number (First 9 chars of second line)
    const passportNumber = secondLine.substring(0, 9).replace(/</g, '').trim();

    // 4. Parse Dates
    const rawBirthDate = secondLine.substring(13, 19);

    // 5. Parse Gender (Index 20 of second line)
    const mrzGender = secondLine.substring(20, 21);

    // Map the 3-letter MRZ nationality code to the 2-letter code expected by the backend
    const country = this.state.Countries.find(c => c.ThreeLtrCode === nationalityCode);
    const finalNationality = country ? country.Code : nationalityCode;

    this.setState({
      ChangedData: true,
      SurnameME: rawSurname,
      NameME: rawFirstName,
      BirthDateME: this.formatMRZDate(rawBirthDate),
      TravelDocNumberME: passportNumber,
      Gender: mrzGender,
      Nation: finalNationality
    });
  }

  formatMRZDate = (dateString) => {
    if (!dateString || dateString.length < 6 || isNaN(dateString)) return "";
    const year = parseInt(dateString.substring(0, 2), 10);
    const month = dateString.substring(2, 4);
    const day = dateString.substring(4, 6);

    const currentYear = new Date().getFullYear() % 100;
    // Threshold: if YY > currentYear + 10, assume 1900s
    const century = year > (currentYear + 10) ? "19" : "20";
    return `${century}${year}-${month}-${day}`;
  };

  formatSafeDate = (dateStr) => {
    if (!dateStr || dateStr.length < 8) return "";
    try {
      return dateStr.substr(0, 4) + "-" + dateStr.substr(4, 2) + "-" + dateStr.substr(6, 2);
    } catch (e) {
      return "";
    }
  }

  handleChangeOfInputSearchFields = (event) => {
    const { name, value } = event.target;

    // If a massive string is dumped into any field (Keyboard Emulation), intercept it
    if (value.length > 40 && (value.includes('<<') || value.startsWith('P<'))) {
      this.processCleanData(value);

      // Prevent the raw MRZ string from staying in the input field
      // We wait a tick to let the state update from processCleanData
      setTimeout(() => {
        if (name === "SurnameME" && this.state.SurnameME.includes('<')) {
          this.setState({ [name]: this.state.SurnameME.replace(/<.*/, '') });
        }
      }, 10);
      return;
    }
    this.setState({ [name]: value });
  };

  handleChangeOfCombo(event) {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    this.setState({ [fieldName]: fieldValue });
  }

  getTicket = () => {
    let TicketNumberME = this.state.TicketNumberME;
    let username = this.props.username;
    let userGroup = this.props.userGroup;
    let password = this.props.password;
    let ItineraryID = this.props.ItineraryID;
    let lang =
      localStorage.getItem("lang") === "EN" ||
        localStorage.getItem("lang") === "FR" ||
        localStorage.getItem("lang") === "ES"
        ? localStorage.getItem("lang")
        : "EN";
    this.setState({ loadingSpinner: true, ChangedData: false });
    axios
      .post(B2B_PROXY + "/TicketEnquiryForTickNum", {
        TicketNumberME,
        username,
        userGroup,
        password,
        ItineraryID,
        lang,
      })
      .then((res) => {
        if (res.data[0] === "000") {
          this.setState({ PNRME: res.data[4] });
          this.setState({ loadingSpinner: false });
          if (res.data[2].length > 0) {
            this.setState({ SurnameME: res.data[2][0].Surname });
            this.setState({ NameME: res.data[2][0].Name });
            this.setState({ MaidenME: res.data[2][0].MaidenName });
            this.setState({
              BirthDateME: this.formatSafeDate(res.data[2][0].BirthDate)
            });
            this.setState({ BirthPlaceME: res.data[2][0].BirthPlace });
            this.setState({ TravelDocNumberME: res.data[2][0].PassportNumber });
            this.setState({
              TravelDocIssueDateME: this.formatSafeDate(res.data[2][0].PassportDelDate)
            });
            this.setState({ Gender: res.data[2][0].Gender });
            this.setState({ SpecialServ: res.data[2][0].SpecialServicesReq });
            this.setState({ OccupationME: res.data[2][0].Occupation });
            this.setState({ ComingFromME: res.data[2][0].CommingFrom });
            this.setState({ GoingToME: res.data[2][0].GoingTo });
            this.setState({
              AddressMoroccoME: res.data[2][0].AddressInMorocco,
            });
            this.setState({
              PhoneDuringStayME: res.data[2][0].PhoneDuringStay,
            });
            this.setState({ AccomTypePass: res.data[2][0].AgeCategory });
            this.setState({ VisitReasonME: res.data[2][0].MainReasonForVisit });
            this.setState({
              CabinSeatNumberME: res.data[2][0].CabinSeatNumber,
            });
            this.setState({ BerthME: res.data[2][0].Berth });
            this.setState({ VisaNumberME: res.data[2][0].VisaNumber });
            this.setState({ bookId: res.data[2][0].BookID });

            this.setState({ Nation: res.data[2][0].Nationality });
            this.setState({
              ResidCountry: res.data[2][0].CountryOfUsualResidence,
            });

            for (let i = 0; i < this.state.Docs.length; i++) {
              if (
                res.data[2][0].DocType.trim() === this.state.Docs[i].TMSACode
              ) {
                this.setState({
                  DocType: res.data[2][0].DocType.trim(),
                });
              }
            }

            for (let i = 0; i < this.state.Countries.length; i++) {
              if (this.state.Countries[i].Code === res.data[2][0].Nationality) {
                this.setState({
                  Nation: res.data[2][0].Nationality,
                });
              }

              if (
                this.state.Countries[i].ThreeLtrCode ===
                res.data[2][0].CountryOfUsualResidence
              ) {
                this.setState({
                  ResidCountry: res.data[2][0].CountryOfUsualResidence,
                });
              }
            }

            for (let i = 0; i < this.state.AgeType.length; i++) {
              if (this.state.AgeType[i].Code === res.data[2][0].AgeCategory) {
                this.setState({
                  AgeCateg: res.data[2][0].AgeCategory,
                });
              }
            }

            for (let i = 0; i < this.state.AccomPass.length; i++) {
              if (
                this.state.AccomPass[i].Code ===
                res.data[2][0].AccommodationType
              ) {
                this.setState({
                  AccomTypePass: res.data[2][0].AccommodationType,
                });
              }
            }
          } else if (res.data[3].length > 0) {
            this.setState({
              RegistrationPlatesME: res.data[3][0].RegistrationNumber,
            });
            this.setState({ DriverNameME: res.data[3][0].DriverName });
            this.setState({ LengthME: res.data[3][0].Length });
            this.setState({ HeightME: res.data[3][0].Height });
            this.setState({ ModelME: res.data[3][0].Model });
            this.setState({ BrandME: res.data[3][0].Brand });
            this.setState({ AccomTypeVeh: res.data[3][0].VehicleType });
            this.setState({ bookId: res.data[3][0].BookID });

            for (let i = 0; i < this.state.AccomVeh.length; i++) {
              if (
                this.state.AccomVeh[i].Code === res.data[3][0].AccommodationType
              ) {
                this.setState({
                  AccomTypeVeh: res.data[3][0].AccommodationType,
                });
              }
            }
          }
        } else {
          ToastStore.error(res.data.StatusMessage);
          this.setState({ loadingSpinner: false });
        }
      });
  };

  saveManualEntry = () => {
    const data = {
      manualEntryPassenger: this.props.manualEntryPassenger,
      username: this.state.username,
      userGroup: this.state.userGroup,
      password: this.state.password,
      TicketNumberME: this.state.TicketNumberME,
      ItineraryID: this.props.ItineraryID,
      SailID: this.props.SailID,
      PNRME: this.state.PNRME,
      SurnameME: this.state.SurnameME,
      NameME: this.state.NameME,
      MaidenME: this.state.MaidenME,
      BirthDateME: this.state.BirthDateME,
      BirthPlaceME: this.state.BirthPlaceME,
      TravelDocNumberME: this.state.TravelDocNumberME,
      TravelDocIssueDateME: this.state.TravelDocIssueDateME,
      OccupationME: this.state.OccupationME,
      ComingFromME: this.state.ComingFromME,
      GoingToME: this.state.GoingToME,
      AddressMoroccoME: this.state.AddressMoroccoME,
      PhoneDuringStayME: this.state.PhoneDuringStayME,
      VisitReasonME: this.state.VisitReasonME,
      CabinSeatNumberME: this.state.CabinSeatNumberME,
      BerthME: this.state.BerthME,
      VisaNumberME: this.state.VisaNumberME,
      companyAbbreviation: this.props.companyAbbreviation,
      RegistrationPlatesME: this.state.RegistrationPlatesME,
      DriverNameME: this.state.DriverNameME,
      LengthME: this.state.LengthME,
      HeightME: this.state.HeightME,
      ModelME: this.state.ModelME,
      BrandME: this.state.BrandME,
      AgeCateg: this.state.AgeCateg,
      Gender: this.state.Gender,
      Nation: this.state.Nation,
      SpecialServ: this.state.SpecialServ,
      DocType: this.state.DocType.trim(),
      ResidCountry: this.state.ResidCountry,
      AccomTypePass: this.state.AccomTypePass,
      AccomTypeVeh: this.state.AccomTypeVeh,
      BookID: this.props.editData.BookID,
      IsMRZScannedME: this.state.ChangedData ? "1" : "0",
    };

    this.setState({ loadingSpinner: true });
    axios.post(B2B_PROXY + "/embarkationDataUpdate", { data }).then((res) => {
      if (res.data.StatusCode === "000") {
        ToastStore.success(res.data.StatusMessage);
        this.props.fetchReservation();
        this.setState({ loadingSpinner: false });
      } else {
        ToastStore.error(res.data.StatusMessage);
        this.setState({ loadingSpinner: false });
      }
    });
  };

  deleteManualEntry = () => {
    const data = {
      manualEntryPassenger: this.props.manualEntryPassenger,
      username: this.state.username,
      userGroup: this.state.userGroup,
      password: this.state.password,
      TicketNumberME: this.state.TicketNumberME,
      ItineraryID: this.props.ItineraryID,
      SailID: this.props.SailID,
      PNRME: this.state.PNRME,
      SurnameME: this.state.SurnameME,
      NameME: this.state.NameME,
      MaidenME: this.state.MaidenME,
      BirthDateME: this.state.BirthDateME,
      BirthPlaceME: this.state.BirthPlaceME,
      TravelDocNumberME: this.state.TravelDocNumberME,
      TravelDocIssueDateME: this.state.TravelDocIssueDateME,
      OccupationME: this.state.OccupationME,
      ComingFromME: this.state.ComingFromME,
      GoingToME: this.state.GoingToME,
      AddressMoroccoME: this.state.AddressMoroccoME,
      PhoneDuringStayME: this.state.PhoneDuringStayME,
      VisitReasonME: this.state.VisitReasonME,
      CabinSeatNumberME: this.state.CabinSeatNumberME,
      BerthME: this.state.BerthME,
      VisaNumberME: this.state.VisaNumberME,
      companyAbbreviation: this.props.companyAbbreviation,
      RegistrationPlatesME: this.state.RegistrationPlatesME,
      DriverNameME: this.state.DriverNameME,
      LengthME: this.state.LengthME,
      HeightME: this.state.HeightME,
      ModelME: this.state.ModelME,
      BrandME: this.state.BrandME,
      AgeCateg: this.state.AgeCateg,
      Gender: this.state.Gender,
      Nation: this.state.Nation,
      SpecialServ: this.state.SpecialServ,
      DocType: this.state.DocType,
      ResidCountry: this.state.ResidCountry,
      AccomTypePass: this.state.AccomTypePass,
      AccomTypeVeh: this.state.AccomTypeVeh,
    };

    if (this.state.TicketNumberME !== "" && this.state.PNRME !== "") {
      this.setState({ loadingSpinner: true });
      axios
        .post(B2B_PROXY + "/DeleteTicket", {
          data,
        })
        .then((res) => {
          if (res.data.StatusCode === "000") {
            ToastStore.success(res.data.StatusMessage);
            this.setState({ loadingSpinner: false });
          } else {
            ToastStore.error(res.data.StatusMessage);
            this.setState({ loadingSpinner: false });
          }
        });
    }
  };

  componentDidMount() {
    axios.get(B2B_PROXY + "/Countries").then((res) => {
      const CountriesMap = res.data.map((obj) => ({
        Code: obj.Code,
        ThreeLtrCode: obj.ThreeLtrCode,
        Name: obj.Name,
      }));
      this.setState({ Countries: CountriesMap }, () => {
        for (let i = 0; i < this.state.Countries.length; i++) {
          if (
            this.state.Countries[i].Code === this.props.editData.Nationality
          ) {
            this.setState({
              Nation: this.props.editData.Nationality,
            });
          }

          if (
            this.state.Countries[i].ThreeLtrCode ===
            this.props.editData.CountryOfUsualResidence
          ) {
            this.setState({
              ResidCountry: this.props.editData.CountryOfUsualResidence,
            });
          }
        }
      });
    });

    let companyAbbr = this.state.companyAbbreviation;
    if (this.props.manualEntryPassenger) {
      axios.get(B2B_PROXY + "/DocIndex").then((res) => {
        const DocsMap = res.data.map((obj) => ({
          TMSACode: obj.TMSACode,
          Description: obj.Description,
        }));
        this.setState({ Docs: DocsMap }, () => {
          for (let i = 0; i < this.state.Docs.length; i++) {
            if (
              this.props.editData.DocType.trim() === this.state.Docs[i].TMSACode
            ) {
              this.setState({
                DocType: this.props.editData.DocType.trim(),
              });
            }
          }
        });
      });
    }

    axios.get(B2B_PROXY + "/AccomsVeh").then((res) => {
      const AgeType = res.data[0].map((obj) => ({
        Type: obj.Type,
        Code: obj.Code,
        Name: obj.Name,
      }));

      this.setState({ AgeType }, () => {
        for (let i = 0; i < this.state.AgeType.length; i++) {
          if (this.props.editData.AgeCategory === this.state.AgeType[i].Code) {
            this.setState({
              AgeCateg: this.props.editData.AgeCategory,
            });
          }
        }
      });
    });

    axios.post(B2B_PROXY + "/AccomPerComp", { companyAbbr }).then((res) => {
      const AccomPass = res.data.AccomPass.map((obj) => ({
        Type: obj.Type,
        Company: obj.Company,
        Code: obj.Code,
        Name: obj.Name,
        PortGenericCode: obj.PortGenericCode,
        PortGenericName: obj.PortGenericName,
      }));
      const AccomVeh = res.data.AccomVeh.map((obj) => ({
        Type: obj.Type,
        Company: obj.Company,
        Code: obj.Code,
        Name: obj.Name,
        PortGenericCode: obj.PortGenericCode,
        PortGenericName: obj.PortGenericName,
      }));
      this.setState({ AccomPass }, () => {
        for (let i = 0; i < this.state.AccomPass.length; i++) {
          if (
            this.props.editData.AccommodationType ===
            this.state.AccomPass[i].Code
          ) {
            this.setState({
              AccomTypePass: this.props.editData.AccommodationType,
            });
          }
        }
      });
      this.setState({ AccomVeh }, () => {
        for (let i = 0; i < this.state.AccomVeh.length; i++) {
          if (this.props.editData.VehicleType === this.state.AccomVeh[i].Code) {
            this.setState({
              AccomTypeVeh: this.props.editData.VehicleType,
            });
          }
        }
      });
    });
    this.getTicket();
  }

  render() {
    let lang = this.props.lang;
    var countriesSize = this.state.Countries.length;
    let optionItems = [];
    for (var i = 0; i < countriesSize; i++) {
      optionItems.push({
        // @ts-ignore
        abbr: this.state.Countries.Code,
        // @ts-ignore
        country: this.state.Countries.Name,
      });
    }

    return (
      <Modal
        open={this.props.isManualEntryOpen}
        onClose={this.props.onCloseManualEntry}
        center
      >
        <Loader fullPage loading={this.state.loadingSpinner} />
        <Col className="HeaderTicks">{translations[lang]["Edit Ticket"]}</Col>
        <Row>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>{translations[lang]["Ticket Number"]}</ControlLabel>
              <FormControl
                className="well"
                value={this.state.TicketNumberME}
                onChange={(event) => {
                  this.handleChangeOfInputSearchFields(event);
                }}
                name="TicketNumberME"
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>{translations[lang]["Company"]}</ControlLabel>
              <FormControl
                className="well"
                readOnly
                value={this.props.companyAbbreviation}
                type="text"
                name="Company"
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>{translations[lang]["PNR"]}</ControlLabel>
              <FormControl
                className="well"
                name="PNRME"
                value={this.state.PNRME}
                onChange={(event) => {
                  this.handleChangeOfInputSearchFields(event);
                }}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={4} className="d-flex justify-content-between">
            <RadioGroup
              name="manualEntryInputType"
              className="ms-2"
              value={this.props.manualEntryRadioValue}
              onChange={this.props.handleChangeOfManualEntryRadioButton}
            >
              <FormControlLabel
                onClick={this.props.onClickManualEntryPassenger}
                value="passenger"
                control={
                  <Radio
                    color="primary"
                    checked={this.props.manualEntryPassenger}
                  />
                }
                label={translations[lang]["Passenger"]}
              />
              <FormControlLabel
                onClick={this.props.onClickManualEntryVehicle}
                value="vehicle"
                control={
                  <Radio
                    color="primary"
                    checked={this.props.manualEntryVehicle}
                  />
                }
                label={translations[lang]["Vehicle"]}
              />
            </RadioGroup>
          </Col>
          <Col md={4}>
            <Button
              className="btn btn-primary btn btn-lg "
              bsSize="large"
              type="button"
              onClick={this.getTicket}
            >
              {translations[lang]["Search Ticket"]}
            </Button>
          </Col>
        </Row>
        {this.props.manualEntryPassenger ? (
          <Row className="TicketBlock">
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["Surname"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="SurnameME"
                    type="text"
                    style={this.state.ChangedData ? { border: '3px solid #00cf00' } : {}}
                    value={this.state.SurnameME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    disabled={this.state.ChangedData}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["firstName"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="NameME"
                    type="text"
                    style={this.state.ChangedData ? { border: '3px solid #00cf00' } : {}}
                    value={this.state.NameME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    disabled={this.state.ChangedData}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Maiden Name"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="MaidenME"
                    value={this.state.MaidenME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>{translations[lang]["Age/Cat"]}</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="AgeCateg"
                    value={this.state.AgeCateg}
                    onChange={this.handleChangeOfCombo}
                  >
                    <option value="">Select Category</option>
                    {this.state.AgeType.map((AgeType, index) => {
                      return (
                        <option
                          key={"ageCategory" + index}
                          value={AgeType.Code}
                        >
                          {AgeType.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>{translations[lang]["Gender"]}</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="Gender"
                    style={this.state.ChangedData ? { border: '3px solid #00cf00' } : {}}
                    value={this.state.Gender}
                    onChange={this.handleChangeOfCombo}
                  >
                    <option value="">Select Gender</option>
                    <option value="M">{translations[lang]["Male"]} </option>
                    <option value="F">{translations[lang]["Female"]} </option>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Birth Date"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="BirthDateME"
                    style={this.state.ChangedData ? { border: '3px solid #00cf00' } : {}}
                    value={this.state.BirthDateME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="date"
                    disabled={this.state.ChangedData}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Nationality"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    style={this.state.ChangedData ? { border: '3px solid #00cf00' } : {}}
                    value={this.state.Nation}
                    name="Nation"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option value="">Select Nationality </option>
                    {this.state.Countries.map((Country, index) => {
                      return (
                        <option key={index} value={Country.Code}>
                          {Country.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Birth Place"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="BirthPlaceME"
                    value={this.state.BirthPlaceME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Special Service Req."]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.SpecialServ}
                    name="SpecialServ"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option value="NO">{translations[lang]["NO"]} </option>
                    <option value="YES">{translations[lang]["YES"]} </option>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Document Type"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.DocType}
                    name="DocType"
                    onChange={this.handleChangeOfCombo}
                  >
                    {this.state.Docs.map((Document, index) => {
                      return (
                        <option key={index} value={Document.TMSACode}>
                          {Document.Description}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Travel Doc. Number"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="TravelDocNumberME"
                    style={this.state.ChangedData ? { border: '3px solid #00cf00' } : {}}
                    value={this.state.TravelDocNumberME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                    disabled={this.state.ChangedData}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Travel Doc. Issue Date"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="TravelDocIssueDateME"
                    value={this.state.TravelDocIssueDateME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="date"
                  />
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Occupation"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="OccupationME"
                    value={this.state.OccupationME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Coming From"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="ComingFromME"
                    value={this.state.ComingFromME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["Going To"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="GoingToME"
                    value={this.state.GoingToME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Residence Country"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.ResidCountry}
                    name="ResidCountry"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option value="">Select Country</option>
                    {this.state.Countries.map((Country, index) => {
                      return (
                        <option
                          key={"ResCountry" + Country.ThreeLtrCode}
                          value={Country.Code}
                        >
                          {Country.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Address in Morocco"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="AddressMoroccoME"
                    value={this.state.AddressMoroccoME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Phone During Stay"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="PhoneDuringStayME"
                    value={this.state.PhoneDuringStayME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="number"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Visit Reason"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="VisitReasonME"
                    value={this.state.VisitReasonME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Accomodation Type"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.AccomTypePass}
                    name="AccomTypePass"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option value="">Select Accommodation</option>
                    {this.state.AccomPass.map((AccomPass, index) => {
                      return (
                        <option key={index} value={AccomPass.Code}>
                          {AccomPass.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Cabin/Seat Number"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="CabinSeatNumberME"
                    value={this.state.CabinSeatNumberME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["Berth"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="BerthME"
                    value={this.state.BerthME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Visa Number"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="VisaNumberME"
                    value={this.state.VisaNumberME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
            </Col>
          </Row>
        ) : null}
        {this.props.manualEntryVehicle ? (
          <Row className="TicketBlock">
            <Col md={12} className="clear">
              <FormGroup className="left MEform">
                <ControlLabel>
                  {translations[lang]["Vehicle Type"]}
                </ControlLabel>
                <FormControl
                  componentClass="select"
                  value={this.state.AccomTypeVeh}
                  name="AccomTypeVeh"
                  onChange={this.handleChangeOfCombo}
                >
                  {this.state.AccomVeh.map((AccomVeh, index) => {
                    return (
                      <option key={AccomVeh.Code} value={AccomVeh.Code}>
                        {AccomVeh.Name}
                      </option>
                    );
                  })}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>
                  {translations[lang]["Registration Plates"]}
                </ControlLabel>
                <FormControl
                  className="well"
                  name="RegistrationPlatesME"
                  value={this.state.RegistrationPlatesME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Driver Name"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="DriverNameME"
                  value={this.state.DriverNameME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Length (cm)"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="LengthME"
                  value={this.state.LengthME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Height (cm)"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="HeightME"
                  value={this.state.HeightME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Model"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="ModelME"
                  value={this.state.ModelME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left ">
                <ControlLabel>{translations[lang]["Brand"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="BrandME"
                  value={this.state.BrandME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
        ) : null}
        <Row style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <div className="col-md-3 col-sm-6 col-xs-12">
            <Button
              className="btn-danger"
              bsSize="large"
              type="button"
              onClick={() => {
                this.deleteManualEntry();
              }}
              style={{ width: '100%' }}
            >
              Delete
            </Button>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12">
            <Button
              className="btn-primary"
              bsSize="large"
              type="button"
              onClick={() => {
                this.saveManualEntry();
              }}
              style={{ width: '100%' }}
            >
              Save
            </Button>
          </div>
          {this.props.canUseMRZ && (
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div style={{ 
                padding: '6px 12px', 
                borderRadius: '4px', 
                background: this.props.port ? 'rgba(46, 204, 113, 0.1)' : 'rgba(231, 76, 60, 0.1)',
                border: this.props.port ? '1px solid #2ecc71' : '1px solid #e74c3c',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '46px',
                width: '100%',
                boxSizing: 'border-box',
                alignSelf: 'center'
              }}>
                <span style={{ 
                  color: this.props.port ? '#2ecc71' : '#e74c3c', 
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>
                  {this.props.port ? '✓ Scanner Ready' : '✕ Scanner Disconnected'}
                </span>
              </div>
              {this.props.personTickets.length > 9 && (
                <div style={{ color: "#ff8080", marginTop: "5px", fontSize: '11px', textAlign: 'center' }}>
                  MRZ scan is limited to 9 passengers.
                </div>
              )}
            </div>
          )}
        </Row>
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={
            // @ts-ignore
            ToastContainer.POSITION.TOP_CENTER
          }
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditTicket.js